 

export class SaveWorkrequestRequest {
    
    public buildingId: string;
    public workrequestId: number;
    public notes: string;
    public status: string;
    constructor(init?:Partial<SaveWorkrequestRequest>) {
        
        Object.assign(this, init);
    }
}



// WEBPACK FOOTER //
// ./models/SaveWorkrequestRequest.ts